var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.hasElipsis)?_c('span',{directives:[{name:"tippy",rawName:"v-tippy"}],attrs:{"title":("<b>" + _vm.extraData + "</b><br/> " + _vm.title)}},[_vm._v("\n      "+_vm._s(_vm.extraData)+"\n    ")]):_c('span',{directives:[{name:"tippy",rawName:"v-tippy"}],attrs:{"title":_vm.title}},[_vm._v("\n    "+_vm._s(_vm.extraData)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b369bd7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/HasElipsis.vue
// module id = Eybe
// module chunks = 66